/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/

import { SchemaType } from '@/scripts/shareModels/schema';

export interface Request {
  method: string;
  path: string;
  payload: SchemaType;
}

export interface Response {
  status: number;
  payload: SchemaType;
}
export interface Endpoint {
  id?: string;
  apiId: string;
  flows: string[];
  request: Request;
  response: Response;
}

export interface API {
  id?: string;
  name: string;
  path: string;
  workspaceId: string;
  apiKey?: string;
  endpoints?: Endpoint[]
}

export const emptyAPI: API = {
  id: '',
  name: '',
  path: '',
  apiKey: '',
  workspaceId: '',
  endpoints: [],
};

export const emptyEndpoint: Endpoint = {
  apiId: '',
  flows: [],
  request: { method: '', path: '', payload: { name: '', type: '' } },
  response: { status: 0, payload: { name: '', type: '' } },
};

export interface APIState {
  apis: API[],
  loading: boolean
}
